var AppConfig = {
   baseUrl: "https://sifv6-utf.ine.mx/portal-rendicion-cuentas/api/", //url base del backend
   baseUrlSecondary: "https://seg-utf-sif.ine.mx/portal-rendicion-cuentas/api/", //url secundaria del backend en caso que la primaria sea inalcanzable
   username: "user", // usuario para autenticación en backend
   password: "password", // contraseña para autenticación en backend

   /* endpoints  */
   campaniaDataTable: "contabilidad/cam",
   ordinarioDataTable: "contabilidad/todas",
   procesosElectoralesFiltro: "contabilidad/procesosElectorales/",
   procesos: "contabilidad/cProcesos/",
   ambitosFiltro: "contabilidad/ambitos/",
   entidadesFiltro: "contabilidad/entidades/",
   municipiosFiltro: "contabilidad/municipios",
   distritosFiltro: "contabilidad/distritos",
   actoresFiltro: "contabilidad/sujetosObligados/",
   cargosFiltro: "contabilidad/cargos",
   contabilidadesList: "contabilidad/lista",
   contabilidadesConteo: "contabilidad/conteo",
   ordinarioProcesosGeneralesFiltro: "contabilidad/ordinario/procesosElectorales",
   ordinarioComitesFiltro: "contabilidad/ordinario/comites/",
   ordinarioEntidadesFiltro: "contabilidad/ordinario/entidades/",
   ordinarioSujetosObligadosFiltro: "contabilidad/ordinario/sujetosObligados/",
   ordinarioContabilidadesLista: "contabilidad/ordinario/lista",
   ordinarioContabilidadesConteo: "contabilidad/ordinario/conteo",
   campanaDetalle: "contabilidad/campana/detalle/",
   ordinarioDetalle: "contabilidad/ordinario/detalle/",
   pdfDummy: "base64",

   /* constantes */
   orderFieldDefault: "NOMBRESCANDIDATO",
   orderFieldOrdinaryDefault: "NOMBRESO",
   orderTypeDefault: "ASC",
   indexFirstElementDefault: 0,
   pageMaxSizeDefault: 10,
   nameDefault: null,
   searchMode: "searchMode",
   resultMode: "resultMode",
   ambitoTipoConf: 1,

   ambitoFederal: 1,
   ambitoLocal: 2,
};

export default AppConfig;
